module.exports = __webpack_public_path__ + "img/pxp-logo.9adc858d.svg";